/**
 * Enum with all known hierarchy definition unique identifiers (System IDs).
 */
 export enum Hierarchy {
    Performance = '4dac038d-2045-47e0-9cce-a3e273d2347c',
    Dynamic = 'c06b29d0-7e03-4e2f-9c2a-62d725140c3b'
}
